import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report-folder" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "report-folder-name" }
const _hoisted_4 = {
  key: 0,
  class: "report-folder-body"
}
const _hoisted_5 = {
  key: 0,
  class: "report-empty"
}

import { computed, ref } from "vue";
import { FolderIcon } from "@heroicons/vue/24/solid";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";
import ReportRow from "@/components/reports/ReportRow.vue";
import type { ReportFolder, ReportItem, ReportExportFormat } from "@/types/reports";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportFolderAccordion',
  props: {
    folder: {}
  },
  emits: ["select", "toggle-favorite", "download"],
  setup(__props: any) {

const props = __props;



const expanded = ref<boolean>(true);

const sortedReports = computed<ReportItem[]>(() =>
  [...props.folder.reports].sort((a, b) => a.sortOrder - b.sortOrder)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "report-folder-header",
      "aria-expanded": expanded.value ? 'true' : 'false',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, [
      _createVNode(_unref(FolderIcon), { class: "report-folder-icon" }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.folder.name), 1),
      (expanded.value)
        ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
            key: 0,
            class: "report-folder-chevron-icon"
          }))
        : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
            key: 1,
            class: "report-folder-chevron-icon"
          }))
    ], 8, _hoisted_2),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "report-row-header" }, [
            _createElementVNode("span", { class: "col-name" }, "Report Name"),
            _createElementVNode("span", { class: "col-refreshed" }, "Last Refreshed"),
            _createElementVNode("span", { class: "col-actions" })
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedReports.value, (report) => {
            return (_openBlock(), _createBlock(ReportRow, {
              key: report.id,
              report: report,
              onSelect: ($event: any) => (_ctx.$emit('select', report)),
              onToggleFavorite: ($event: any) => (_ctx.$emit('toggle-favorite', report)),
              onDownload: _cache[1] || (_cache[1] = (r, fmt) => _ctx.$emit('download', r, fmt))
            }, null, 8, ["report", "onSelect", "onToggleFavorite"]))
          }), 128)),
          (sortedReports.value.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " No reports in this folder. "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})